import {ProposalFilter} from "../../../service/proposal.service";
import {sanitizeFilterObject} from "../../../service/http.service";

export function proposalFilter(filter: ProposalFilter) {
    const out = { ...filter }
    if (out.id) {
        out.id = out.id + "%";
    }
    if (out.name) {
        out.name = "%" + out.name + "%";
    }
    if (out.phone) {
        out.phone = "%" + out.phone + "%";
    }
    if (out.address) {
        out.address = "%" + out.address + "%";
    }
    if(out.polygon && out.polygon.length > 0) {
        //@ts-ignore
        out.polygon = out.polygon.map(p => {
            return p.lat + "," + p.lng
        })
    } else {
        out.polygon = undefined;
    }
    return sanitizeFilterObject(out);
}


export function priceRender(price: number) {
    if (!price) {
        return null;
    }
    const noCents = Math.round(price / 100).toString();
    if(noCents === '0') {
        const out = ("" + (price / 100)).substring(0, 5);
        if(out === '0.00') {
            return '>0.00'
        } else {
            return out;
        }
    } else {
        return noCents.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
}


export function perSquareMeter(price: number, area: number, highLight: boolean) {
    if (!isFinite(price) || isNaN(price)) {
        return null;
    }
    if (!isFinite(area) || isNaN(area) || area === 0) {
        return null;
    }
    const result = priceRender((price / area) * 100);
    return <div className={highLight ? 'filter-highlight' : ''}>{result}</div>;
}


export const imageStyle = {
    height: '50px',
    maxWidth: '100px'
}
